var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-section"},[_c('img',{staticClass:"banner-image",attrs:{"src":_vm.bannerImage},on:{"click":function($event){return _vm.goToChat()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }